import enUS from '@/locales/en-US.json'
import { createI18n } from 'vue-i18n'

export type i18nMessageSchema = typeof enUS

export const i18nModule = createI18n<i18nMessageSchema, 'en-US', false>({
  legacy: false,
  locale: 'en-US',
  messages: {
    'en-US': enUS,
  },
})
